module.exports = __webpack_public_path__ + "media/images/companies/smbc_vc-1dba241086f777ca337019cc674fef23.png";